define('container/moduleLoaders/FactoryServiceLoader',['underscore', 'bluebird'], function(_, Promise) {

    'use strict';

    /**
     * Use this to use an existing service, or its property as a factory for other services.
     *
     * Service definition usage examples:
     *
     *      { factoryService: 'nameOfService' }
     *      { factoryService: 'nameOfService.propertyName' }
     */
    function FactoryServiceLoader() {
    }

    FactoryServiceLoader.prototype.canLoadModule = function(extensionApi) {
        return !!extensionApi.serviceDefinition.factoryService;
    };

    FactoryServiceLoader.prototype.loadModule = function(extensionApi) {

        var parts = extensionApi.serviceDefinition.factoryService.split('.'),
            serviceId = parts[0],
            propertyName = parts[1];

        return extensionApi.container.get(serviceId).then(function(instance) {

            if (!propertyName) {
                return instance;
            }

            if (!instance[propertyName]) {
                throw new Error('Service "' + serviceId + '" has no property "' + propertyName + '".');
            }

            if (_.isFunction(instance[propertyName])) {
                return instance[propertyName].bind(instance);
            }

            return instance[propertyName];
        });
    };

    return FactoryServiceLoader;
});

